































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { ApplyWithdraw, QueryShopBankCardList } from '@/api'
import { Message } from 'element-ui'
import { ElForm } from 'element-ui/types/form'
import { VImageUpload } from '@/components/upload'
import {getUser} from '@/store/userStore'

@Component({
  components: {
    VImageUpload,
  },
})
export default class RestPwdDialog extends Vue {
  private show = false
  private data: any = {amount:'',withdrawAmount:'',bankCardId:''}
  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  // 自定义金额范围验证规则
  private validateAmountRange = (rule: any, value: any, callback: any) => {
      // 转换为数字
      const num = Number(value);

      // 验证是否为空
      if (!value) {
        return callback(new Error('请输入金额'));
      }

      // 验证是否为有效数字
      if (isNaN(num)) {
        return callback(new Error('请输入有效的数字'));
      }

      // 验证是否在指定范围（例如 0 到 1000 之间）
      if (num < 10 || num > 20000) {
        return callback(new Error('提现金额必须在 10 到 20000 之间'));
      }

      // 验证通过
      callback();
    };
  private rules = {
    amount: [this.requiredRule,{ validator: this.validateAmountRange, trigger: 'blur' }],
    bankCardId: [this.requiredRule],
  }
  private amount: any = 0 // 提现金额
  private balance: any = 0 // 余额

  private bankCardList: any[] = []

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.show = false
    this.data = {amount:'',withdrawAmount:'',bankCardId:''}
  }

  @Emit('success')
  private success() {
    // 触发
  }

  private  userInfo = getUser()
  private get feeAmoun(){
    if(this.userInfo.user.shop.shopType == 1){
      // 1个体工商户  手续费1元
      return 1;
    }
    return 2;
  }

  public created(){
    this.loadQueryShopBankCardList()
  }

  public open(withdrawAmount: number) {
    this.show = true
    // this.data.withdrawAmount = withdrawAmount
    this.data.amount = (withdrawAmount/100).toFixed(2)
    // 单次最大提现额度为2万
    if(this.data.amount > 20000){
      this.data.amount = 20000
    }
    this.balance = (withdrawAmount/100).toFixed(2)
    if(this.bankCardList.length > 0){
      this.data.bankCardId = this.bankCardList[0].id
    }
  }

  public async save() {
    const f = this.$refs.form as ElForm
    f.validate(async (success: boolean) => {
      if (!success) {
        return
      }
      const param = {...this.data}
      param.withdrawAmount = (this.data.amount*100).toFixed(0)
      ApplyWithdraw(param).then(res=>{
        if(res){
          Message.success('提交成功')
          this.close()
          this.success()
        }
      })

    })
  }

  // 加载银行卡
  private loadQueryShopBankCardList(){
    QueryShopBankCardList({pageSize:1000}).then(res=>{
      this.bankCardList = res.list
    })
  }
}
